import React from 'react';
import PayNet from './PayNet.js';
 
export default (props) => <PayNet {...props}/>;
